// extracted by mini-css-extract-plugin
module.exports = {"communityGridItem":"style_communityGridItem__lxe9e","communityGridItem__svg":"style_communityGridItem__svg__nPcJs","communityGridItem__text":"style_communityGridItem__text___fbvG"};